import React from "react";
import SignUpImage from "../images/image-5.png";
import VisitorsHeader from "../component/vistorsheader";
import Bottom from "../component/bottom-section";
import Footer from "../component/footer";
import SignUpForm2 from "./SignUpForm2";
import { useParams } from "react-router-dom";
import { IoMdCheckmark } from "react-icons/io";
const Register2 = () => {
  let { regMail } = useParams();

  const currentStep = 2;

  return (
    <div>
      {console.log(`This is the email that i am trying to log out ${regMail}`)}
      <VisitorsHeader />
      <>
        <div className="flex py-4 my-3 w-[95%] lg:w-[85%] mx-auto flex-col lg:flex-row min-h-screen justify-between">
          <div className="lg:w-1/2 md:hidden hidden lg:block ">
            <img src={SignUpImage} alt="Sign Up" className=" w-full h-[98vh]" />
          </div>

          <div className="lg:w-1/2 flex items-center justify-center lg:px-8 px-3 mt-4">
            <div className="max-w-md w-full">

              <div className="mb-12">
                <div className="relative flex items-center justify-between">
                  {[1, 2, 3, 4].map((step, index) => {
                    if (index < 3) {
                      return (
                        <div
                          key={`line-${index}`}
                          className={`absolute h-1 ${
                            step <= 2 ? "bg-blue-500" : "bg-gray-300"
                          }`}
                          style={{
                            left: `${(index * 100) / 3}%`,
                            right: `${100 - ((index + 1) * 100) / 3}%`,
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        />
                      );
                    }
                    return null;
                  })}

                  {[1, 2, 3, 4, 5].map((step) => (
                    <div
                      key={step}
                      className="relative z-10 flex flex-col items-center"
                    >
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 border-2 ${
                          step < currentStep
                            ? "bg-[#405AC6] border-[#405AC6] text-white"
                            : step === currentStep
                            ? "bg-white border-[#405AC6] text-[#405AC6]" 
                            : "bg-white border-gray-300 text-gray-500" 
                        }`}
                      >
                        {step < currentStep ? (
                          <IoMdCheckmark className="w-5 h-5" /> 
                        ) : (
                          `0${step}` 
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <SignUpForm2 regMail={regMail} />
            </div>
          </div>
        </div>
      </>
      <Bottom />
      <Footer />
    </div>
  );
};

export default Register2;
